import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PERMISSION_ROLE_KEYS } from './core/models/permission-keys';
import { AuthGuard } from './core/services/auth.guard';
import { RoleGuard } from './core/services/role.guard';
import { DashboardsComponent } from './modules/dashboards/dashboards.component';
import { DashboardsModule } from './modules/dashboards/dashboards.module';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => DashboardsModule,
    canActivate: [AuthGuard, RoleGuard],
    canActivateChild: [AuthGuard, RoleGuard],
    data: {
      rejectRoles: [PERMISSION_ROLE_KEYS.ROLE_EXTERNAL]
    }
  },
  {
    path: 'flights',
    component: DashboardsComponent,
    loadChildren: () => import('./modules/dashboards/masters/flights/flights.module').then(m => m.FlightsModule),
    canActivate: [AuthGuard, RoleGuard],
    canActivateChild: [AuthGuard, RoleGuard],
  },
  {
    path: 'user-profile',
    component: DashboardsComponent,
    loadChildren: () => import('./modules/external-user-config/external-user-config.module').then(m => m.ExternalUserConfigModule),
    canActivate: [AuthGuard, RoleGuard],
    canActivateChild: [AuthGuard, RoleGuard],
  },
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'loginext', loadChildren: () => import('./modules/login-external/login-external.module').then(m => m.LoginExternalModule) },
  { path: 'recovery', loadChildren: () => import('./modules/recovery/recovery.module').then(m => m.RecoveryModule) },
  { path: 'reset', loadChildren: () => import('./modules/recovery-password/recovery-password.module').then(m => m.RecoveryPasswordModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
